module.exports = __webpack_public_path__ + "img/404-bnn.5e3262f4.svg";